import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  termsOfService: {
    id: 'adminPortal.emailTemplateForm.termsOfService',
    defaultMessage: 'Terms of Service',
  },
  privacyPolicy: {
    id: 'adminPortal.emailTemplateForm.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
  support: {
    id: 'adminPortal.emailTemplateForm.support',
    defaultMessage: 'Support',
  },
});

export default messages;
